import { ShieldCheck, Mail, Cookie, Database, Users2 } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen py-16" data-testid="privacy-policy-page">
      <div className="max-w-4xl mx-auto px-4 md:px-8 lg:px-12">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-6">
          Política de Privacidade
        </h1>
        <p className="text-lg text-muted-foreground mb-12">
          Última atualização: julho de 2026
        </p>

        <div className="prose prose-lg max-w-none space-y-10">
          <section>
            <p className="text-lg leading-relaxed mb-4">
              O Bitcoin Atlas ("nós", "nosso site") respeita a privacidade de quem visita
              <strong> bitcoinatlas.me</strong> e leva a sério a proteção de dados pessoais, em
              conformidade com a Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018). Esta
              página explica quais informações coletamos, para que usamos, com quem compartilhamos
              e quais direitos você tem sobre seus próprios dados.
            </p>
          </section>

          <section className="bg-card border border-border rounded-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <Database className="text-primary" size={28} />
              <h2 className="text-2xl font-bold m-0">Quais dados coletamos</h2>
            </div>
            <ul className="space-y-3 text-muted-foreground">
              <li>
                <strong>Newsletter:</strong> quando você se inscreve, coletamos seu nome e e-mail,
                usados exclusivamente para enviar o resumo diário de notícias sobre Bitcoin.
              </li>
              <li>
                <strong>Formulário de contato:</strong> nome, e-mail e a mensagem que você escrever,
                usados só para responder sua solicitação.
              </li>
              <li>
                <strong>Dados de navegação:</strong> contamos visualizações de artigos de forma
                agregada e anônima, para entender quais conteúdos têm mais interesse. Isso não
                identifica você individualmente.
              </li>
            </ul>
            <p className="text-muted-foreground mt-4">
              Não pedimos, e você nunca deve nos enviar, documentos, senhas, chaves privadas ou
              seed phrases de carteiras Bitcoin — o Bitcoin Atlas jamais solicita esse tipo de
              informação por nenhum canal.
            </p>
          </section>

          <section className="bg-card border border-border rounded-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <Users2 className="text-primary" size={28} />
              <h2 className="text-2xl font-bold m-0">Com quem compartilhamos dados</h2>
            </div>
            <p className="text-muted-foreground mb-3">
              Não vendemos seus dados pessoais. Compartilhamos informações apenas com prestadores
              de serviço que nos ajudam a operar o site, cada um sujeito às próprias políticas de
              privacidade:
            </p>
            <ul className="space-y-2 text-muted-foreground">
              <li><strong>MongoDB Atlas:</strong> armazenamento do banco de dados do site.</li>
              <li><strong>Resend:</strong> envio dos e-mails de newsletter e de contato.</li>
              <li>
                <strong>Google AdSense:</strong> exibição de anúncios no site (veja a seção de
                cookies abaixo para mais detalhes).
              </li>
            </ul>
          </section>

          <section className="bg-card border border-border rounded-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <Cookie className="text-primary" size={28} />
              <h2 className="text-2xl font-bold m-0">Cookies e publicidade</h2>
            </div>
            <p className="text-muted-foreground mb-3">
              Usamos o Google AdSense para exibir anúncios. O Google e seus parceiros publicitários
              podem usar cookies e identificadores para exibir anúncios com base em suas visitas a
              este e a outros sites. Isso é chamado de publicidade personalizada.
            </p>
            <p className="text-muted-foreground">
              Você pode desativar a publicidade personalizada visitando as{' '}
              <a
                href="https://adssettings.google.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline"
              >
                Configurações de anúncios do Google
              </a>
              , ou o portal{' '}
              <a
                href="https://www.aboutads.info/choices/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline"
              >
                www.aboutads.info/choices
              </a>
              , sem que isso afete sua navegação normal pelo site.
            </p>
          </section>

          <section className="bg-card border border-border rounded-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <ShieldCheck className="text-primary" size={28} />
              <h2 className="text-2xl font-bold m-0">Seus direitos (LGPD)</h2>
            </div>
            <p className="text-muted-foreground mb-3">Você pode, a qualquer momento, solicitar:</p>
            <ul className="space-y-2 text-muted-foreground">
              <li>Confirmação de que tratamos seus dados, e acesso a eles</li>
              <li>Correção de dados incompletos ou desatualizados</li>
              <li>Exclusão dos seus dados (ex: descadastro da newsletter)</li>
              <li>Revogação do consentimento dado anteriormente</li>
              <li>Informação sobre com quem compartilhamos seus dados</li>
            </ul>
            <p className="text-muted-foreground mt-4">
              Para se descadastrar da newsletter, basta usar o link de descadastro presente em
              qualquer e-mail enviado por nós, ou entrar em contato conosco diretamente.
            </p>
          </section>

          <section className="bg-primary/10 border-2 border-primary rounded-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <Mail className="text-primary" size={28} />
              <h2 className="text-2xl font-bold m-0">Fale conosco</h2>
            </div>
            <p className="text-muted-foreground">
              Dúvidas sobre esta política ou pedidos relacionados aos seus dados podem ser
              enviados para{' '}
              <a href="mailto:contato@bitcoinatlas.com" className="text-primary underline">
                contato@bitcoinatlas.com
              </a>{' '}
              ou pela nossa{' '}
              <a href="/contato" className="text-primary underline">
                página de contato
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3">Alterações a esta política</h2>
            <p className="text-muted-foreground">
              Podemos atualizar esta Política de Privacidade periodicamente para refletir mudanças
              em nossas práticas ou por exigências legais. A data no topo desta página indica a
              versão mais recente.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
